export default __webpack_public_path__ + "static/media/globeGreen_menu.f46ce663.png";